module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAuElEQVRIS8XWsQ3DMAwEwOdmySYeIatkAq/iETKKMwEDFQIMFxbJf0dqJej4DUnDpGOTXMhhd3+Y2TYKJIXdfQGwAnib2esKl8EH9Augpf7cDmfRVhCduILScBWlYAYtwyxaghVoGlahKViJhmE1GoLvQLPwDuA5aoWj4dDvQ53rkFqGh+BWpRoPw2o8BSvxNKzCS7ACL8MsTsEMTsNVXAJXcBl8wv+33vYePGWhjw6I0HTKfJZ5+wOxtJYf9RdQtAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/users/Return.png
// module id = nR/i
// module chunks = 0